import { render, staticRenderFns } from "./DatatableHeading.vue?vue&type=template&id=8688e908&"
import script from "./DatatableHeading.vue?vue&type=script&lang=js&"
export * from "./DatatableHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports